const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const OtpPasswordCommand: any = {
    UpdateEndpointRateLimit: Backofficebff + '/v1/smsratelimit/update-endpoint-rate-limit',
};
